<template>
  <div class="progress fixed-top nx-web-socket-connection" style="height: 3px">
    <div
      :title="`${$t('general.liveConnection')}: ${webSocketClientReadyState}`"
      class="progress-bar"
      :class="`${webSocketClientReadyStateClass}`"
      role="progressbar"
      style="width: 100%"
    ></div>
  </div>
</template>

<script>
export default {
  name: "WebSocketConnection",
  data() {
    return {
      webSocketClientReadyStateClass: "bg-light",
      webSocketClientReadyState: "",
    };
  },
  watch: {
    "$root.webSocketClient": {
      handler(val) {
        switch (val?.conn?.readyState) {
          case 0:
            this.webSocketClientReadyState = this.$t(
              "webSocketState.connecting"
            );
            this.webSocketClientReadyStateClass = "bg-warning";
            break;
          case 1:
            this.webSocketClientReadyState = this.$t("webSocketState.open");
            this.webSocketClientReadyStateClass = "bg-success";
            break;
          case 2:
            this.webSocketClientReadyState = this.$t("webSocketState.closing");
            this.webSocketClientReadyStateClass = "bg-warning";
            break;
          case 3:
            this.webSocketClientReadyState = this.$t("webSocketState.closed");
            this.webSocketClientReadyStateClass = "bg-danger";
            break;
          default:
            this.webSocketClientReadyState = this.$t("webSocketState.unknown");
            this.webSocketClientReadyStateClass = "bg-secondary";
            break;
        }
      },
      deep: true,
    },
  },
};
</script>
<style lang="scss">
.nx-web-socket-connection {
  border-radius: 0 !important;
}
</style>
